import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart, Repeat, ShieldCheck } from "lucide-react";

export const CircleBand = () => {
  return (
    <section className="relative overflow-hidden bg-primary text-primary-foreground">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, hsl(var(--accent)) 0, transparent 40%), radial-gradient(circle at 80% 80%, hsl(var(--accent)) 0, transparent 40%)",
        }}
      />
      <div className="container relative mx-auto grid gap-10 px-4 py-20 md:grid-cols-[1.2fr_1fr] md:items-center">
        <div>
          <span className="inline-block rounded-full bg-accent/20 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-accent">
            The Circle • Monthly Giving
          </span>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight md:text-5xl">
            Join The Circle
          </h2>
          <p className="mt-4 max-w-xl text-lg text-primary-foreground/80">
            100% of your gift funds projects in Sri Lanka. Become a monthly
            donor and power the highest-priority education, health, and
            disaster recovery work — every month.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              asChild
              size="lg"
              className="rounded-full bg-accent px-8 text-accent-foreground hover:bg-accent/90"
            >
              <Link to="/the-circle">Join The Circle</Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="rounded-full border-primary-foreground/30 bg-transparent px-8 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
            >
              <Link to="/the-circle#how-it-works">How it works</Link>
            </Button>
          </div>
        </div>

        <ul className="grid gap-4 sm:grid-cols-1">
          {[
            {
              icon: Repeat,
              title: "Reliable monthly impact",
              body: "From $15/month — predictable funding lets us plan ahead and respond faster.",
            },
            {
              icon: Heart,
              title: "100% to programs",
              body: "Every dollar is allocated to vetted projects across Sri Lanka.",
            },
            {
              icon: ShieldCheck,
              title: "US 501(c)(3) tax-deductible",
              body: "You'll receive an automatic annual receipt for your gifts.",
            },
          ].map(({ icon: Icon, title, body }) => (
            <li
              key={title}
              className="flex gap-4 rounded-2xl border border-primary-foreground/15 bg-primary-foreground/5 p-5 backdrop-blur"
            >
              <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-accent/20 text-accent">
                <Icon className="h-5 w-5" />
              </span>
              <div>
                <p className="font-semibold">{title}</p>
                <p className="mt-1 text-sm text-primary-foreground/75">{body}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CircleBand;
